import { render, staticRenderFns } from "./ImageUploader.component.vue?vue&type=template&id=2d2cb8d0&scoped=true"
import script from "./ImageUploader.component.vue?vue&type=script&lang=js"
export * from "./ImageUploader.component.vue?vue&type=script&lang=js"
import style0 from "./ImageUploader.component.vue?vue&type=style&index=0&id=2d2cb8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2cb8d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAvatar,VCard})
